import {gql} from '@apollo/client';

export const GET_SORTER_PLAN_FLOW = gql`
    query GetSorterPlanFlow($sorterPlanId: ID!) {
        getSorterPlanFlow(sorterPlanId: $sorterPlanId) {
            success
            message
            data {
                businessType
                businessTypeName
                carrierCode
                carrierName
                printType
                printTypeName
                sortingCode
                ttBizType
                ttBizTypeName
                preSortingCode
                lastMileSortingCode
                validChuteCount
                physicalChuteCount
                chuteNumbers
                chuteType
                exceptionCodes
            }
        }
    }
`;

export interface FlowItem {
    businessType?: number;
    businessTypeName?: string;
    carrierCode?: number;
    carrierName?: string;
    printType?: number;
    printTypeName?: string;
    sortingCode?: string;
    ttBizType?: string | null;
    ttBizTypeName?: string | null;
    preSortingCode?: string;
    lastMileSortingCode?: string;
    validChuteCount: number;
    physicalChuteCount: number;
    chuteNumbers: string;
    chuteType?: number;
    exceptionCodes?: string[] | null;
}

export interface FlowQueryResult {
    getSorterPlanFlow: {
        success: boolean;
        message?: string;
        data: FlowItem[];
    };
}

